
<template>
  <div class="new-course">
    <div class="newCourseContent">
      <ul>
        <li class="courseItem" v-for="item in pageDataList" :key="item.id" @click="goToCourseDetail(item.id || item.course.id )">
          <div class="courseName">{{ item.title || item.course.title}}</div>
          <div class="courseTime">
            {{ item.published_at || item.course.published_at}} - {{ item.end_at || item.course.published_at}}
          </div>
          <div class="courseTag">
            <span
              class="red"
              v-for="(hotItem, hotIndex) in item.hot_word"
              :key="hotIndex + '11'"
              >{{ hotItem }}</span
            >
            <span
              class="green"
              v-for="(buteItem, buteIndex) in item.attribute"
              :key="buteIndex + '33'"
              >{{ buteItem }}</span
            >
          </div>

          <div class="courseInfo">
            <div class="courseTeachers">
              <img
                v-for="(teacherItem, teacherIndex) in item.teacher"
                :key="teacherIndex + '22'"
                class="avatar-img"
                :src="teacherItem.avatar"
                alt=""
              />
            </div>

            <div class="coursePrice">
              <span style="font-weight: bold">¥{{item.charge || item.course.charge}}</span>
            </div>
          </div>
          <div class="classroom-info-split"></div>
          <div class="courseMessage">
            <span class="studentnum"> {{item.user_count || 300 }}人已购买</span>
          </div>
          <!-- </div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script >
// import { mostNewCourse } from '../../utils/api/courseManage'

//新上好课的数据
// let newCourse = ref([]);

// onBeforeMount(()=>{
// 	mostNewCourse({
// 		pageNum:1,
// 		pageSize:8
// 	}).then(res=>{
// 		newCourse.value = res.data.pageInfo.list;
// 		console.log( res.data.pageInfo.list )
// 	})
// })

export default {
  props: {
    pageDataList: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {};
  },

  methods: {
    goToCourseDetail(e) {
      this.$router.push({
        path: `/course/detail/${e}`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.new-course {
  width: 1200px;
  margin: 0 auto;
  margin-top: 15px;
}
.contentTitle {
  display: flex;
  justify-content: space-between;
}
.contentTitle-left {
  display: flex;
}
.hot {
  display: flex;
  height: 38px;
}
.hot-l {
  height: 38px;
  font-size: 20px;
  padding: 0 10px;
  text-align: center;
  line-height: 37px;
  color: #ffffff;
  border-radius: 8px 0 8px 8px;
  background: linear-gradient(90deg, #ff727f 0%, #fc685c 100%);
}
.hot-r {
  width: 0;
  height: 0;
  border: 6px solid #fc685c;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.txt {
  position: relative;
  height: 38px;
  margin-left: 10px;
}
.txt-top {
  font-size: 24px;
  padding: 0 5px;
  color: #222222;
  line-height: 31px;
}
.txt-bottom {
  position: absolute;
  top: 25px;
  left: 0px;
  width: 100%;
  height: 13px;
  background: linear-gradient(90deg, #fbf84f 0%, #fea935 100%);
  border-radius: 7px;
  z-index: -1;
}
.more {
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #808080;
}
.newCourseContent {
  width: 1200px;
  margin: 20px auto 0px auto;
}
.newCourseContent ul {
  display: flex;
  flex-wrap: wrap;
}
.courseItem {
  width: 380px;
  // height: 252px;
  background: rgba(255, 255, 255, 0.39);
  box-shadow: 1px 1px 10px rgb(27 39 94 / 40%);
  border-radius: 8px;
  margin: 0 30px 34px 0;
  padding: 14px;
  transition: margin-top 0.2s;
}
.courseItem:hover {
  margin-top: -10px;
  cursor: pointer;
}
.courseItem:nth-child(3n + 0) {
  margin-right: 0 !important;
}
.courseTag {
  // font-family: Source Han Sans CN;
  // font-weight: 300;
  // font-size: 12px;
  // line-height: 20px;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
  span {
    border-radius: 2.2px;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 1;
    padding: 4px 6px;
    margin-right: 10px;
    max-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom: 3px;

  }
  .green {
    color: #0fce96;
    background: #e5fff7;
  }
  .red {
    background: #ffebe4;
    color: #ff3d00;
  }
}
.avatar-img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.courseTeachers {
  display: inline-block;
  text-align: center;
}
.courseInfo {
  margin-top: 40px;
  margin-bottom: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.courseBg {
  position: relative;
  width: 100%;
  height: 160px;
}
.courseBg img {
  width: 100%;
  height: 100%;
}
.courseName {
  font-size: 18px;
  color: #040404;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  color: #040404;
  line-height: 28px;

  // margin: 10px;
  // font-weight: bold;
  // font-size: 14px;
  // color: #333333;
  // display: -webkit-box;
  // overflow: hidden;
}
.courseTime {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 15px;
  margin: 14px;
}
.coursePrice {
  font-size: 14px;
  margin-top: 18px;
  padding: 0 13px;
  color: #ff3d00;
  font-weight: 700;
}
.studentnum {
  float: right;
  margin-top: 12px;
  font-size: 12px;
  color: #bcbcbc;
}
</style>